import { IconProps } from 'blaze-ui/icons/Types'
import { forwardRef } from 'react'

export const X = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Brand-logos">
        <rect width="20" height="20" rx="5" fill="#15171A" />
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2692 3.87498L10.6928 8.06271L7.83633 3.87498H3.87104L8.48841 10.6442L3.80769 16.1247H5.4207L9.20456 11.694L12.2268 16.1247H16.1921L11.4091 9.11273L15.8822 3.87498H14.2692ZM12.9431 14.9351L9.96635 10.6461V10.6458L6.11701 5.0994H7.11137L13.9375 14.9351H12.9431Z"
          fill="white"
        />
      </g>
    </svg>
  )
})

export default X
